import styled from 'styled-components'

export const ListingsContainer = styled.div`
  height: 100%;
  display: flex;
  flex-direction: column;
  gap: 12px;
  background: ${({ theme }) => theme.colors.background.primary};

  @media (max-width: ${({ theme }) => theme.breakpoints.mobile}) {
    padding: 12px;
  }
`

export const ListingsStatsSection = styled.div`
  background: ${({ theme }) => theme.colors.background.primary};
  border-radius: 6px;
  padding-top: 16px;
`

export const ListingsMetricCard = styled.div<{
  $highlight?: boolean
  $accent?: boolean
}>`
  background: ${({ $highlight, $accent, theme }) =>
    $accent
      ? `linear-gradient(135deg, ${theme.colors.primary}10 0%, ${theme.colors.primary}05 100%)`
      : $highlight
        ? theme.colors.background.secondary
        : theme.colors.background.primary};
  border: 1px solid ${({ theme }) => theme.colors.border.light};
  border-radius: 6px;
  padding: 12px;
  min-width: 120px;
  transition: all 0.2s ease;

  &:hover {
    transform: translateY(-2px);
    box-shadow: ${({ theme }) => theme.shadows.sm};
  }

  @media (max-width: ${({ theme }) => theme.breakpoints.mobile}) {
    flex: 1 1 45%;
    min-width: 130px;
  }
`

export const ListingsMetricLabel = styled.div`
  display: flex;
  align-items: center;
  gap: 5px;
  font-size: 10px;
  color: ${({ theme }) => theme.colors.text.secondary};
  text-transform: uppercase;
  letter-spacing: 0.5px;
  margin-bottom: 6px;
`

export const ListingsMetricValue = styled.div<{ color?: string }>`
  font-size: 16px;
  font-weight: 700;
  color: ${({ color, theme }) => color || theme.colors.text.primary};
  margin-bottom: 3px;
`

export const ListingsEmptyState = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 320px;
  padding: 38px 20px;
  background: ${({ theme }) => theme.colors.background.primary};
  border-radius: 6px;
  border: 2px dashed ${({ theme }) => theme.colors.border.light};
`

export const ListingsEmptyStateIcon = styled.div`
  width: 64px;
  height: 64px;
  border-radius: 50%;
  background: ${({ theme }) => theme.colors.background.secondary};
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 20px;
`

export const ListingsEmptyStateText = styled.div`
  text-align: center;
  max-width: 320px;
`
